  import { defineComponent, type PropType } from "vue";
  import AdresseSummary from '@/extend/controls/adresse/AdresseSummary';
  import LieuLabel from '@/extend/controls/lieu/LieuLabel';
  import Lieu from '@/extend/classes/Lieu';
  import { FieldStatus, EditFieldTheme, SectionStatus } from '@/framework/base/components/FieldInfo';
  import { Alerts } from '@/framework/base/helpers/Alerts'; 
  import { storeLieu } from '@/generated/stores';
  import LoaderButton from '@/framework/base/components/LoaderButton.vue';
  import SectionHeader from '@/framework/base/components/SectionHeader.vue';
  import { Extended } from '@/framework/base/classes/Schema';
  import ButtonPlus from '@/framework/base/components/ButtonPlus.vue';
  import Route from '@/generated/classes/Route';
  import { Fiches, Sections } from '@/generated/classes/AppSchema';
  import { ObjTypes } from '@/generated/classes/ObjTypes';
  import GraphControl from '@/framework/graph/components/GraphControl.vue';
  import { GraphAnswer, GraphMinimum } from '@/generated/classes/GraphData';
  export default defineComponent({
    components: {
      SectionHeader,
      LoaderButton,
      ButtonPlus,
      GraphControl,
      AdresseSummary,
      LieuLabel,
    },

    props: {
      lieu: {
        type: Object as PropType<Lieu>,
        required: true
      },
      showButton: {
        type: Boolean,
      },
      autoSave: {
        type: Boolean,
      },
      fieldOnly: {
        type: Boolean,
      },
      extended: {
        type: Boolean,
      },
      autoClear: {
        type: Boolean,
      },
      dialog: {
        type: Boolean,
      },
      closeSection: {
        type: Boolean,
      },
      showMissing: {
        type: Boolean,
      },
      moduleId: {
        type: Number,
      },
      theme: {
        type: Object as PropType<EditFieldTheme>,
      },
      fiche: {
        type: String,
      },
      fromSection: {
        type: String,
      },
      requiredAttributs: {
        type: Array as PropType<string[]>,
      },
    },

    beforeUnmount (): void {
      if (!this.closeSection) {
        this.beforeClose();
      }
    },

    data() {
      return {
        graphStatus: new FieldStatus(false, false, 0),
    toggleAdresseId: false,
        adresseIdStatus: new FieldStatus(false, false, 0),
        strAdresseId: '',
        labelStatus: new FieldStatus(false, false, 0),
        strLabel: '',
        toggleGraph: false,
        refLieu: new Lieu,
        cloneLieu: new Lieu,
      lieuSaving: false,
        saving: false,
        restoring: false,
        inDialog: false,
        updated: false,
        error: false,
        saveLoading: false,
        saveFailed: false,
        allowClearRef: true,
        objType: ObjTypes.LIEU,
        status: new SectionStatus(false, false, false),
        autoClose: true,
        closing: false
      }
    },
    computed: {
      isExtended (): boolean {
        return this.extended;
      },

      exist (): boolean {
        return this.editLieu.id != 0
      },

      extendIcon (): string {
        return this.extended ? 'fas fa-circle-minus' : 'fas fa-circle-plus';
      },

      saveButton (): boolean {
        return (this.showButton == undefined || this.showButton == true) && !this.allReadOnly;
      },

      editLieu: {
        get(): Lieu {
          if (this.closeSection) {
            this.beforeClose();
          } else {
            if (this.lieu != undefined) {
              if (this.lieu.id == 0) {
                Alerts.debug('CrudLieu : les objets passés en paramètre doivent être issus du store (id <> 0)');
              }
              if (this.cloneLieu.id != this.lieu.id && !this.saving) {
                this.handleLieuChange();
              }
            }
          }
          return this.refLieu;
        },
        set(value: Lieu) {
          this.refLieu = value;
        }
      },

      canCreate (): boolean {
        return this.refLieu.id > 0;
      },

      canDelete (): boolean {
        return this.refLieu.canDelete && this.refLieu.id > 0;
      },

      updatedAndValid (): boolean {
        return this.updated && !this.error;
      },
      graphAnswers: {
        get(): GraphAnswer[] {
          return this.editLieu.graphAnswers;
        },
        set(value: GraphAnswer[]) {
          this.editLieu.graphAnswers = value;
        }
      },

      clearAuto (): boolean {
        return (this.autoClear == undefined || this.autoClear == true) && this.allowClearRef;
      },

    resetAdresseId (): boolean {
      return this.toggleAdresseId
    },

      adresseId: {
        get(): number {
          return this.editLieu.adresseId;
        },
        set(value: number) {
          this.editLieu.adresseId = value;
          this.fieldUpdated('ADRESSE_ID', value);
        }
      },


      label: {
        get(): string {
          return this.editLieu.label;
        },
        set(value: string) {
          this.editLieu.label = value;
          this.fieldUpdated('LABEL', value);
        }
      },


      allReadOnly (): boolean {
        const res = this.lieu.canUpdate && (
        (this.isDisplayed('ADRESSE_ID') && !this.readOnly('ADRESSE_ID')) ||
        (this.isDisplayed('LABEL') && !this.readOnly('LABEL')) ||
        (this.isDisplayed('GRAPH_CONTROL') && !this.readOnly('GRAPH_CONTROL')));
        return !res;
      },

      fields (): string[] {
        return ['ADRESSE_ID', 'LABEL'];
      },
    },

    methods: {
      handleLieuChange() : void {
        // Edited object changed
        this.saveFailed = false;
        this.toggleGraph = !this.toggleGraph;
        if (this.autoSave && this.updatedAndValid) {
          if (!this.inDialog && this.checkFields()) {
            // Dialogue to save or cancel changes
            this.inDialog = true;
            this.dialogSaveOrCancel().then(() => {
              this.createRef(this.lieu);
              this.inDialog = false;
                  })
          } else if (!this.restoring && !this.inDialog) {
            this.restoreEdited();
            this.createRef(this.lieu);
          }
        } else if (!this.inDialog) {
          if (this.cloneLieu.id < 0) {
            this.clearRef();
          } else if (this.updated) {
            this.restoreEdited();
          }
          this.createRef(this.lieu);
        }
      },
      beforeClose (): void {
        if (!this.closing) {
          this.closing = true;
          if (this.autoSave && this.updatedAndValid && this.checkFields()) {
            this.$emit('saveOrCancel');
            this.dialogSaveOrCancel();
          } else {
            if (this.autoSave && this.updated) {
              this.restoreEdited();
            }
            this.$emit('cancelled');
          }
          this.clearRef();
          }
      },

      setExtended (extended: Extended): void {
         this.$emit('extended', extended);
      },

      // eslint-disable-next-line
      isDisplayed (value: string): boolean {
        return true;
      },

      // eslint-disable-next-line
      required (value: string): boolean {
        return false;
      },

      // eslint-disable-next-line
      readOnly (value: string): boolean {
        return false;
      },

      save (): void {
        if (event != undefined) {
          event.stopPropagation();
        }
        this.saveLoading = true;
        this.saveFailed = false;
        if (this.checkFields()) {
          this.saveObj();
        } else {
        this.saveLoading = false;
          this.saveFailed = true;
        }
      },

      setUpdated (): void {
        const updated = (this.adresseIdStatus != undefined && this.adresseIdStatus.updated) ||
          (this.labelStatus != undefined && this.labelStatus.updated) ||
          (this.graphStatus != undefined && this.graphStatus.updated);
        if (updated != this.updated) {
          this.updated = updated;
          this.status.updated = updated;
          this.status.missing = this.hasMissing();
          if (!this.closing) {
            this.$emit('status', this.status);
          }
          this.$emit('updated', this.lieu);
        }
      },

      setError (): void {
        const error = this.adresseIdStatus.error ||
        this.labelStatus.error ||
          this.graphStatus.error;
        if (error != this.error) {
          if (!error) {
            this.saveFailed = false;
          }
          this.error = error;
          this.status.error = error;
          if (!this.closing) {
            this.$emit('status', this.status);
          }
          this.$emit('updated', this.lieu);
        }
      },

      setMinimum(value: GraphMinimum): void {
        this.editLieu.graphMinimum = value;
      },

      statusGraph(value: FieldStatus): void {
        this.graphStatus = value;
        this.setUpdated();
        this.setError();
      },

      // Clear non saved new objects when leaving
      clearRef (): void {
        if (this.clearAuto && this.refLieu.id < 0) {
          storeLieu.mLieuDeleted(this.refLieu.id);
        }
      },

      // Dialog to save or ignore changes when loosing focus or changing edited item
      dialogSaveOrCancel (): Promise<boolean> {
        return new Promise((resolve) => {
          if (!this.error) {
            Alerts.saveOrCancel()
              .then((result: boolean) => {
                if (result) {
                  this.saveObj();
                } else {
                  if (this.refLieu.id <= 0) {
                    this.deleteObj();
                  } else {
                    this.restoreEdited();
                  }
                  this.$emit('cancelled');
                }
                resolve(result);
              })
          } else {
            this.restoreEdited();
          }
        })
      },

      // Save object and subobjects referenced by foreignClass keys
      saveObj (): void {
        this.saving = true;
        if (
          this.saveLieu()
          ) {
          this.toggleGraph = !this.toggleGraph;
          this.saving = false;
          this.saveLoading = false;
          this.lieuSaving = false;
          this.createRef(this.refLieu);
          this.$emit('updated', this.refLieu);
          if (this.lieu.id > 0) {
            this.$emit('saved', this.refLieu);
          } else {
            this.updated = true;
          }
          if (this.autoClose) {
            this.saveFields();
            this.$emit('closeDialog');
          }
        } else {
          if (this.refLieu.failed) {
          this.saveLoading = false;
            this.lieuSaving = false;
            this.refLieu.failed = false;
          }
        }
      },

      saveLieu (): boolean {
        if (!this.refLieu.compareLieu(this.cloneLieu)) {
          if (!this.lieuSaving) {
            this.lieuSaving = true;
          if (this.refLieu.id > 0) {
            storeLieu.updateLieu(this.refLieu)
              .then((data: Lieu) => {
                if (!data.failed) {
                  this.refLieu = storeLieu.getLieu(data.id);
                  this.cloneLieu = data.cloneLieu();
                } else {
                  this.refLieu.failed = true;
                }
                this.saveObj();
              })
              .catch(() => {
                this.restoreEdited();
                this.lieuSaving = false;
                this.saveLoading = false;
              })
          }
            if (this.refLieu.id <= 0) {
              storeLieu.createLieu(this.refLieu)
                .then((data: Lieu) => {
                  if (!data.failed) {
                    this.refLieu = storeLieu.getLieu(data.id);
                    this.cloneLieu = data.cloneLieu();
                  } else {
                this.refLieu.failed = true;
                  }
                  this.saveObj();
                })
                .catch(() => {
                  this.restoreEdited();
                    this.lieuSaving = false;
                })
            }
          }
          return false;
        } else {
          return true;
        }
      },

      // Delete object
      deleteObj (): void {
        if (this.refLieu.id <= 0) {
          storeLieu.mLieuDeleted(this.refLieu.id);
        } else {
          storeLieu.deleteLieu(this.refLieu);
        }
      },

      statusAdresseId (value: FieldStatus): void {
        this.adresseIdStatus = value;
        this.setUpdated();
        this.setError();
      },
      statusLabel (value: FieldStatus): void {
        this.labelStatus = value;
        this.setUpdated();
        this.setError();
      },

      deleteLieu(): void {
        this.$emit('deleteLieu',  this.lieu);
      },

    addLieu(): void {
      this.$emit('addLieu',  this.lieu);
    },

      // Restore object
      restoreEdited (): void {
        if (this.cloneLieu != undefined) {
          this.restoring = true;
          this.refLieu.label = this.cloneLieu.label;
          this.restoring = false;
        }
      },


    // Clone and clear edited
      createRef (value: Lieu): void {
        this.clearRef();
        this.editLieu = value;
        this.cloneLieu = value.cloneLieu();
        this.adresseIdStatus.clear(value.id);
        this.labelStatus.clear(value.id);
        this.graphStatus.clear(value.id);
        this.status.clear();
      },

    checkFields (): boolean {
        // @ts-expect-error : generated method
        if (this.isDisplayed('ADRESSE_ID') && this.$refs.ADRESSE_ID) this.$refs.ADRESSE_ID.touch();
        // @ts-expect-error : generated method
        if (this.isDisplayed('LABEL') && this.$refs.LABEL) this.$refs.LABEL.touch();
        // @ts-expect-error : generated method
        if (this.isDisplayed('GRAPH_CONTROL') && this.$refs.GRAPH_CONTROL) this.$refs.GRAPH_CONTROL.touch();
        return !this.error;
      },

      missing (value: string): boolean {
        return this.hasMissing(value);
      },

      hasMissing (value = ''): boolean {
        let missing = false;
        // @ts-expect-error : generated method
        if ((value == '' || value == 'ADRESSE_ID') && this.isDisplayed('ADRESSE_ID') && this.$refs.ADRESSE_ID && this.$refs.ADRESSE_ID.missing()) missing = true;
        // @ts-expect-error : generated method
        if ((value == '' || value == 'LABEL') && this.isDisplayed('LABEL') && this.$refs.LABEL && this.$refs.LABEL.missing()) missing = true;
        // @ts-expect-error : generated method
        if ((value == '' || value == 'GRAPH_CONTROL') && this.isDisplayed('GRAPH_CONTROL') && this.$refs.GRAPH_CONTROL && this.$refs.GRAPH_CONTROL.missing()) missing = true;
        return missing;
      },

      saveFields (): void {
        // @ts-expect-error : generated method
        if (this.isDisplayed('ADRESSE_ID') && this.$refs.ADRESSE_ID) this.$refs.ADRESSE_ID.save();
        // @ts-expect-error : generated method
        if (this.isDisplayed('LABEL') && this.$refs.LABEL) this.$refs.LABEL.save();
      },

      getValue (field: string): string {
         if (field == 'ADRESSE_ID') return this.adresseId.toString();
        else  if (field == 'LABEL') return this.label.toString();
        else return '';
      },

    // eslint-disable-next-line
    fieldUpdated (field: string, value: unknown): void {
      // To implement
    },

      setFocus (route: Route): boolean {
        let res = false;
        let first = '';
        const attribut = route ? route.attribut : '';
        this.fields.forEach(field => {
          // @ts-expect-error : generated method
          if (!res && this.isDisplayed(field) && !this.readOnly(field) && this.$refs[field].setFocus) {
            if (attribut == field) {
              // @ts-expect-error : generated method
              this.$refs[attribut].setFocus();
              res = true;
            } else if (first == '') {
              first = field;
            }
          }
        })
        // @ts-expect-error : generated method
        if (!res && first != '' && this.$refs[first] && this.$refs[first].setFocus) {
          // @ts-expect-error : generated method
          this.$refs[first].setFocus();
          res = true;
        }
        return res
      },

      closeDialog(): void {
        this.$emit('closeDialog')
      }
    },
  })
